document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;
  let grupoSeleccionado = "ninas";
  let edadSeleccionada = "1-a-3";

  if (path.includes("ninos")) grupoSeleccionado = "ninos";
  else if (path.includes("bebes-ninos")) grupoSeleccionado = "bebes-ninos";
  else if (path.includes("bebes-ninas")) grupoSeleccionado = "bebes-ninas";

  const botonesEdad = document.querySelectorAll(
    '[href*="ninas-1-a-3-anos"], [href*="ninas-4-a-12-anos"], [href*="ninos-1-a-3-anos"], [href*="ninos-4-a-12-anos"], [href*="bebes-ninas"], [href*="bebes-ninos"]'
  );

  const enlacesRopa = document.querySelectorAll(
    '.mega-menu__link[href*="/collections/"]'
  );

  const enlacesOriginales = Array.from(enlacesRopa).map((enlace) => ({
    element: enlace,
    texto: enlace.textContent.trim().toUpperCase(),
    contenedor: enlace.closest("li"),
    base: enlace.getAttribute("href").split("/").pop().split("-")[0]
  }));

  const coleccionesDisponibles = {
    "ninas": {
      "1-a-3": ["ABRIGOS", "BLUSAS Y CAMISAS", "BODIES", "CAMISETAS", "SUDADERAS Y JERSEYS", "VESTIDOS", "MONOS Y PETOS", "PIJAMAS", "SHORTS Y FALDAS", "PANTALONES Y LEGGINGS", "BAÑADORES", "BABEROS", "CALCETINES", "CHUPETEROS", "DIADEMAS", "GORROS", "MANTITAS", "SETS", "ZAPATILLAS, BOTAS Y SANDALIAS", "GORROS Y BUFANDAS"],
      "4-a-12": ["ABRIGOS", "BLUSAS Y CAMISAS", "CAMISETAS", "SUDADERAS Y JERSEYS", "VESTIDOS", "MONOS Y PETOS", "PIJAMAS", "SHORTS Y FALDAS", "PANTALONES Y LEGGINGS", "BAÑADORES", "BRAGUITAS", "GORROS Y BUFANDAS", "DIADEMAS", "CALCETINES", "ZAPATILLAS, BOTAS Y SANDALIAS"]
    },
    "ninos": {
      "1-a-3": ["ABRIGOS", "BAÑADORES", "BERMUDAS", "CAMISETAS", "BODIES", "CAMISAS", "MONOS Y PETOS", "PANTALONES Y LEGGINGS", "PIJAMAS", "SUDADERAS Y JERSEYS", "ZAPATILLAS, BOTAS Y SANDALIAS", "CALCETINES", "GORROS Y BUFANDAS"],
      "4-a-12": ["ABRIGOS", "BAÑADORES",  "BERMUDAS", "CAMISETAS", "CAMISAS", "MONOS Y PETOS", "PANTALONES Y LEGGINGS", "PIJAMAS", "SUDADERAS Y JERSEYS", "ZAPATILLAS, BOTAS Y SANDALIAS", "CALCETINES", "GORROS Y BUFANDAS"]
    },
    "bebes-ninas": {
      "1-a-3": ["ABRIGOS", "BODIES", "BLUSAS Y CAMISETAS", "MONOS Y PETOS","VESTIDOS", "SUDADERAS Y JERSEYS", "SHORTS Y FALDAS", "PANTALONES Y LEGGINGS", "BAÑADORES", "PIJAMAS", "GORROS", "CHUPETEROS", "BABEROS", "MANTITAS", "CALCETINES", "DIADEMAS", "SETS", "ZAPATILLAS, BOTAS Y SANDALIAS"]
    },
    "bebes-ninos": {
      "1-a-3": ["ABRIGOS", "BODIES", "CAMISETAS", "CAMISAS", "MONOS Y PETOS", "SUDADERAS Y JERSEYS", "SHORTS Y BERMUDAS", "PANTALONES Y LEGGINGS", "BAÑADORES", "PIJAMAS", "GORROS", "CHUPETEROS", "BABEROS", "MANTITAS", "CALCETINES", "SETS", "ZAPATILLAS, BOTAS Y SANDALIAS"]
    }
  };

  function actualizarLinks() {
    enlacesOriginales.forEach(({ element, texto, contenedor, base }) => {
      const nuevoHref = `/collections/${base}-${grupoSeleccionado}-${edadSeleccionada}`;
      element.setAttribute("href", nuevoHref);

      const disponibles = coleccionesDisponibles[grupoSeleccionado]?.[edadSeleccionada] || [];
      contenedor?.classList.toggle("d-none", !disponibles.includes(texto));
    });

    botonesEdad.forEach((b) => b.classList.remove("is-active"));
    const targetHref = `${grupoSeleccionado}-${edadSeleccionada}-anos`;
    const activo = Array.from(botonesEdad).find((b) => b.getAttribute("href")?.includes(targetHref));
    activo?.classList.add("is-active");
  }

  function activarCambio(grupo, edad) {
    grupoSeleccionado = grupo;
    edadSeleccionada = edad;
    actualizarLinks();
  }

  function detectarYActivar(href) {
    if (href.includes("ninas-4-a-12-anos")) return activarCambio("ninas", "4-a-12");
    if (href.includes("ninas-1-a-3-anos")) return activarCambio("ninas", "1-a-3");
    if (href.includes("ninos-4-a-12-anos")) return activarCambio("ninos", "4-a-12");
    if (href.includes("ninos-1-a-3-anos")) return activarCambio("ninos", "1-a-3");
    if (href.includes("bebes-ninas")) return activarCambio("bebes-ninas", "1-a-3");
    if (href.includes("bebes-ninos")) return activarCambio("bebes-ninos", "1-a-3");
  }

  // Activación inicial
  activarCambio(grupoSeleccionado, edadSeleccionada);

  botonesEdad.forEach((boton) => {
    boton.addEventListener("mouseenter", () => {
      if (window.innerWidth > 768) detectarYActivar(boton.href);
    });
    boton.addEventListener("click", (e) => {
      if (window.innerWidth > 768) detectarYActivar(boton.href);
    });
  });
});

